export default String.raw`
$(document).ready(function() {
    const popupBanner = document.querySelector('.popup-timer-js');
    if (!popupBanner) {
        return;
    }

    newsletterPopup.init(popupBanner);
});

const newsletterPopup = {
    init: function(popupBanner) {
        this.popupManagment(popupBanner);
        this.newsletterForm();
    },

    popupManagment: function(popupBanner) {
        const currentDate = new Date(Date.now());
        let popupBannerDaysDifference;
        if (__popupBannerDaysDiff) {
            popupBannerDaysDifference = parseInt(__popupBannerDaysDiff);
        } else {
            popupBannerDaysDifference = 30;
        }
        let popupBannerDaysDiff;
        let isPopupBannerSetDate = false;

        $.each(document.cookie.split(/; */), function()  {
            const cookies = this.split('=');
            if(cookies[0] == 'PopupBannerShowDate') {
                isPopupBannerSetDate = true;
                const popupBannerDate = new Date(cookies[1]);
                popupBannerDaysDiff = (currentDate.getTime() - popupBannerDate.getTime())  / (1000 * 3600 * 24); 
            }
        });
        
        if(isPopupBannerSetDate == false || (popupBannerDaysDiff && popupBannerDaysDiff >= popupBannerDaysDifference)) {
            document.cookie = "PopupBannerShowDate=" + currentDate;
            popupBanner.showModal();
        }
    },

    newsletterForm: function() {
        const $form = $(".newsletter-form-js");
    	const $button = $form.find("button");

		$button.on("click", async () => {
            let conditions = true;
            const $tosesRequired = $form.find("input[name='tos']:required");
            if ($tosesRequired.length > 0) {
				for (const obj of $tosesRequired) {
                    const $obj = $(obj);
                    if (!$obj.is(":checked")) {
                        $obj.parent().find("label").addClass("validation-error-js");
                    }
                }

                for (const obj of $tosesRequired) {
                    const $obj = $(obj);
                    if (!$obj.is(":checked")) {
                        conditions = false;
						app.temporaryPopupMessage(undefined, __translations.NewsLetter_Err2, "err");
                        break;
                    }
                }
            }

            const $email = $form.find("input[type='email']");

            if ($email.hasClass("validation-error-js") || $email.val() === "") {
				conditions = false;
				app.temporaryPopupMessage(undefined, __translations.NewsLetter_Err1, "err");

                if (!$email.hasClass("validation-error-js")) {
                    $email.addClass("validation-error-js");
                }
            }

            if (conditions) {
                const $toses = $form.find("input[name='tos']:checked");
                const $channels = $form.find("input[name='channel']");

                const email = $email.val();
				const data = [];
				const keys = [];
				data.push({name: 'email', value: email});

                $toses.each((_i, obj) => {
                    const $obj = $(obj);
                    data.push({ name: 'tos', value: $obj.val().toString()});
                });

                $channels.each((_i, obj) => {
                    const $obj = $(obj);
                    keys.push($obj.val());
                });

				data.push({name: 'channelKey', value: keys.toString()});
				data.push({name: '__action', value: "Newsletter/Subscribe"});
				data.push({name: '__csrf', value: __CSRF});

				$.post(null, data, (mess)=>{
					if (mess.action.Type === "msg") {
						app.temporaryPopupMessage(undefined, mess.action.Message, "msg");
                        $form.find("input[name='email']").val("");
                        $form.find("input[type='checkbox']").prop("checked", false);
                        const dialog = document.querySelector('.popup-timer-js');
                        if (dialog?.open) {
                            dialog.close();
                        }
					} else {
						app.temporaryPopupMessage(undefined, mess.action.Message, "err");
					}
				});
            }
        });
    }
}
`